import {BaseModuleProps} from "../../../../../infrastructure/models/props/base-module-props";
import {EntityMegaHeaderModuleController} from "../entity-mega-header-module.controller";

export class EntityMegaHeaderModuleProps extends BaseModuleProps {
  controller: EntityMegaHeaderModuleController;
}
